import { Reset } from './reset';

export class Confirm extends Reset {
    constructor(
        public email: string,
        public cpf: string,
        public senha: string,
        public senhaConfirmacao: string,
        public token: string
    ) {
        super(email, cpf);
    }
}